module.exports = function(app) {
	'use strict';
	app.directive('uploadPhotoMl',uploadPhotoMl);
	uploadPhotoMl.$inject=['$rootScope', 'API_URL', 'refreshtokenService', 'authtokenService', 'postDataService', 'serverError','alertService','offlineError'];
	function uploadPhotoMl($rootScope, API_URL, refreshtokenService, authtokenService, postDataService, serverError, alertService, offlineError) {
		return {
			restrict: 'E',
			scope: {
                parentObj:"=",
                attachToPost:"=",
                addToMediaLibrary:'='
		    },
		    template: require('./partial/uploadPhotoMl.html'),
		    link: function (scope, element, attrs) {
                var token = authtokenService.getToken();
                var state = 'attachments';
                Dropzone.autoDiscover = false;
                scope.upload_title = ''
                scope.upload_signature = 'Foto:';
                scope.upload_signature_url = '';
                scope.upload_description = '';
                scope.selectedPhotoQuality = {value:'medium'};
                var uploadedFiles = {};
                scope.ranges = {
                    'Today': [moment().startOf('day'), moment().endOf('day')],
                    'Next 30 days': [moment().startOf('day'), moment().add('days', 29).endOf('day')],
                    'Next 90 days': [moment().startOf('day'), moment().add('days', 89).endOf('day')],
                    'Next 12 months': [moment().startOf('day'), moment().add('months', 12).subtract('days', 1).endOf('day')]
                };
                scope.dzOptions = {
                    url :API_URL+'upload',
                    paramName : 'photo',
                    maxFilesize : '500',
                    parallelUploads: 1,
                    acceptedFiles : 'image/jpeg, images/jpg',
                    addRemoveLinks : true,
                    autoProcessQueue : true,
                    dictInvalidFileType: 'This file type is not supported.',
                    dictFileTooBig:'File size too Big',
                    headers:{
                    'x-auth': token,
                    'x-post-id':(scope.attachToPost)? scope.parentObj.postId:undefined  
                    },
                    
                };
                scope.dzMethods = {
                };
                scope.dzCallbacks = {
                    'success' : function(file, xhr, response){
                        if(!scope.parentObj.singleView && scope.attachToPost) return;
                        file.previewElement.classList.remove("dz-error");
                        var data = JSON.parse(response.currentTarget.response);
                        scope.parentObj.data_grid.push(data);
                        uploadedFiles[data._id] = file
                        if(scope.addToMediaLibrary) {
                            scope.$parent.addFileToPhotoLibrary({upload_data:data})
                        }
                    },
                    'error' : function(file,message) {
                        if(message && message.error && message.error.message) {
                            jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
                        }
                    },
                    'sending':function(file, xhr, formData) {
                        if(scope.upload_title) {
                            formData.append('title', scope.upload_title);
                        }
                        if(scope.upload_gallery_title) {
                            formData.append('gallery_title', scope.upload_gallery_title);
                        }
                        if(scope.upload_signature) {
                            formData.append('signature', scope.upload_signature);
                        }
                        if(scope.upload_description) {
                            formData.append('description', scope.upload_description);
                        }
                        if(scope.upload_signature_url) {
                            formData.append('signature_url', scope.upload_signature_url);
                        }
                        if(scope.selectedPhotoQuality.value) {
                            formData.append('quality', scope.selectedPhotoQuality.value);
                        }
                    },
                    'complete':function(file) {
                        if(file.xhr && file.xhr.status == 401) {
                            file.previewElement.classList.remove("dz-error");
                            var promise = refreshtokenService.getAccessToken();
                            promise.then(
                                function(answer) {
                                if(answer==200) {   
                                    var token = authtokenService.getToken();
                                    scope.dzOptions.headers['x-auth'] = token;
                                    if(scope.attachToPost) {
                                        scope.dzOptions.headers['x-post-id'] = scope.parentObj.postId;
                                    }
                                    scope.dzMethods.uploadFile(file)
                                }
                                },
                                function(error) {
                                },
                                function(progress) {
                                // report progress
                            });
                        }
                    }
                };
                scope.firstBound = true;
                var resetRestrictionFunction = function() {
                    scope.$broadcast('clear-daterange');
                    scope.numberOfUses = undefined;
                }
                scope.addPhotoRestriction = function() {
                    resetRestrictionFunction();
                }
                scope.changeDate = function(value) {
                  scope.dateRangevalue = value;
                  scope.switchDate = true;
            
                  if(scope.dateRangevalue) {
                    if(value.startDate && value.endDate) {
                      scope.date_start = value.startDate.format('YYYY-MM-DD');
                      scope.date_end = value.endDate.format('YYYY-MM-DD');
                    } else {
                      scope.date_start = null;
                      scope.date_end = null;
                    }
                  } else {
                      scope.date_start = null;
                      scope.date_end = null;
                  }
                }
                function saveAttachments() {
                    var attachmentsIds = [];
                    for (var i=0; i < scope.parentObj.data_grid.length;i++) {
                        attachmentsIds.push(scope.parentObj.data_grid[i]._id);
                    }
                    scope.restrictions = undefined;
                    if(scope.photoRestriction && (scope.numberOfUses || scope.date_start)) {
                        scope.restrictions = {
                            date_from :  (scope.date_start)? scope.date_start: undefined,
                            date_to :  (scope.date_end)? scope.date_end: undefined,
                            use_max : (scope.numberOfUses)? parseInt(scope.numberOfUses) : undefined
                        }
                    }
                    if(attachmentsIds.length>0) {
                        $rootScope.hasLoaded = false;
                        var saveData = {
                            'ids': attachmentsIds,
                            'title': scope.upload_title,
                            'gallery_title': scope.upload_gallery_title,
                            'signature': scope.upload_signature,
                            'description': scope.upload_description,
                            'signature_url': scope.upload_signature_url,
                            'restrictions': scope.restrictions
                        }
                        var postFunction = function() { 
                            postDataService.save({
                              param1:state,
                              param2:'multi-update'
                            },saveData).$promise.then(function(data){
                                if(scope.addToMediaLibrary) {
                                    scope.$parent.saveUploadedPhoto({'data':saveData})
                                } else {
                                    for(var i = 0; i<scope.parentObj.data_grid.length;i++) {
                                        if(scope.upload_title) {
                                            scope.parentObj.data_grid[i].title = scope.upload_title;
                                        }
                                        if(scope.upload_signature) {
                                            scope.parentObj.data_grid[i].signature = scope.upload_signature;
                                        }
                                        if(scope.upload_description) {
                                            scope.parentObj.data_grid[i].description = scope.upload_description;    
                                        }
                                        if(scope.upload_gallery_title) {
                                            scope.parentObj.data_grid[i].gallery_title = scope.upload_gallery_title;    
                                        }
                                        if(scope.upload_signature_url && scope.parentObj.data_grid[i].meta) {
                                            scope.parentObj.data_grid[i].meta.signature_url = scope.upload_signature_url;    
                                        }
                                    }
                                }
                                $rootScope.hasLoaded = true;
                                alertService('success','Success ', data.message, 2000);
                            }, function(error){
                                if(!window.navigator.onLine) {
                                    offlineError()
                                    $rootScope.hasLoaded = true;
                                    alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                                    return
                                }
                                if(error.status ==401) {
                                    var promise = refreshtokenService.getAccessToken();
                                    promise.then(
                                    function(answer) {
                                        if(answer==200) {
                                        postFunction();
                                        }
                                    },
                                    function(error) {
                                        // report something
                                    },
                                    function(progress) {
                                    // report progress
                                    });
                                } else if(error.status ==502) {
                                    serverError()
                                } else {
                                    alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                                }
                                $rootScope.hasLoaded = true;
                              
                            });
                        }
                        postFunction();
                    }
                }
                scope.saveAttachments = function() {
                    saveAttachments()
                }
                scope.$on('attachment-save', function (evt, data) {
                    saveAttachments()
                })
                scope.$on('delete-photo-from-upload', function (evt, data) {
                    for (var i=0; i < scope.parentObj.data_grid.length;i++) {
                        if(data.id==scope.parentObj.data_grid[i]._id) {
                            scope.dzMethods.removeFile(uploadedFiles[data.id]);
                            scope.parentObj.data_grid.splice(i,1);
                        }
                    }
                })
		    }
        }    
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/uploadPhotoMl/uploadPhotoMlDirective.js
// module id = 454
// module chunks = 0